import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.small};
  width: 100%;
  justify-content: end;
`;

export const ButtonLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
`;

export const GoBackButton = styled.div`
  display: flex;
`;

export const ButtonContainer = styled.div`
  display: flex;

  @media (max-width: 520px) {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const Spinner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.medium};
`;

export const SmallColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`;

export const Row = styled.div`
  display: flex;
  gap: 5px;
  align-items: center;

  @media (max-width: 768px) {
    width: 100%;

    .p-icon-field {
      width: 100%;
    }
  }

  @media (max-width: 400px) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
    width: 100%;
  }
`;

export const RowText = styled.div`
  @media (max-width: 400px) {
    display: none;
  }
`;
